export default __webpack_public_path__ + "static/media/nav-burger-icon.181fa70a.svg";